/**
 * Autocomplete values for combobox.
 * @public
 */
export const ComboboxAutocomplete = {
    inline: "inline",
    list: "list",
    both: "both",
    none: "none",
};
